import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Campaigns from './Campaigns';
import Create from './Create';
import Suppliers from './Suppliers';
import List from './List';
import Fill from './Fill';
import Edit from './Edit';
import Settings from '../Settings';
import './index.css';
import ErrorPage from '../Shared/ErrorPage';

const Checklist = () => {

  return (
    <div className="container p-0">
      <div className="checklist">
        <Routes>
          <Route path="*" element={<ErrorPage />} />
          <Route exact path={`/campaigns`} element={<Campaigns  />} />
          <Route exact path={`/suppliers/:campaignId`} element={<Suppliers  />} />
          <Route path={`/create/:campaignId/:supplierId`} element={<Create  />} />
          <Route exact path={`/create/:campaignId`} element={<Create  />} />
          <Route path={`/list/:campaignId/:supplierId`} element={<List  />} />
          <Route exact path={`/list/:campaignId`} element={<List  />} />
          <Route path={`/fill/:checklistId`} element={<Fill  />} />
          <Route path={`/edit/:checklistId`} element={<Edit  />} />
          <Route path={`/settings/*`} element={<Settings  />} />
        </Routes>
      </div>
    </div>
  );
};

export default Checklist;
